<template>
  <div
    class="input"
    :class="{
      error: vErrors.length > 0 || isError,
    }"
  >
    <div class="input__title" v-if="title">
      {{ title }}
    </div>
    <input
      :type="type"
      class="input__el"
      :title="title"
      :disabled="disabled"
      v-model="text"
      @input="processInput"
      @focus="processFocus"
      @blur="processBlur"
      @keydown.enter="$emit('enter')"
      v-if="!mask"
      ref="inputEl"
      :placeholder="placeholder"
    />
    <input
      :type="type"
      class="input__el"
      :title="title"
      :disabled="disabled"
      v-model="text"
      @input="processInput"
      @focus="processFocus"
      @blur="processBlur"
      @keydown.enter="$emit('enter')"
      v-mask="mask"
      v-else
      ref="inputEl"
      :placeholder="placeholder"
    />
    <div class="input__errors" v-if="vErrors.length > 0">
      <div class="input__error">{{ vErrors[0].$message }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseTextInput',
  model: {
    prop: 'value',
    event: 'update',
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    value: [String, Number],
    hint: {
      type: String,
      default: '',
    },
    closeButton: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    vErrors: {
      type: Array,
      default() {
        return []
      },
    },
    isError: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: [String, Object, Function],
      default: null,
    },
    canCopy: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      text: '',
      isFocused: false,
    }
  },
  created() {
    this.text = this.value === 0 ? this.value : this.value || ''
  },
  mounted() {
    this.$emit('canFocus', this)
  },
  computed: {
    isLabelToTop: function () {
      return (this.text ? this.text.length > 0 : false) || this.isFocused
    },
  },
  watch: {
    value: function () {
      this.text = this.value
    },
  },
  methods: {
    checkAnimation(e) {
      if (e.animationName === 'onAutoFillStart') {
        this.text = this.text + ' '
        this.autofilled = true
      } else if (e.animationName === 'onAutoFillCancel') {
        this.text = this.text + ' '
        this.autofilled = false
      }
    },

    processFocus() {
      this.$emit('textInputFocus')
      this.isFocused = true
    },
    processBlur() {
      this.$emit('textInputBlur')
      this.isFocused = false
    },
    processInput() {
      this.$emit('update:value', this.text)
    },
    copyToClipboard() {
      if (!navigator.clipboard) {
        return
      }

      navigator.clipboard.writeText(this.text).then(
        () => {
          this.$emit('copied')
        },
        (err) => {
          console.error('Async: Could not copy text: ', err)
        }
      )
    },
    focus() {
      this.$refs.inputEl.focus()
    },
  },
  emits: [
    'enter',
    'canFocus',
    'update',
    'textInputFocus',
    'textInputBlur',
    'copied',
    'update:value',
    'enter',
  ],
}
</script>

<style lang="scss" scoped>
.input {
  width: 100%;
  position: relative;
  &__title {
    font-weight: 300;
    font-size: 11px;
    line-height: 13px;
    color: #909cb0;
    padding-left: 10px;
    margin-bottom: 5px;
    max-width: calc(100% - 50px);
  }

  &__el {
    width: 100%;
    padding: 13px 21px 13px 21px;
    height: auto;
    border: 1px solid #f2f4f7;
    border-radius: 8px;
    box-shadow: unset;

    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #666d79;

    position: relative;
    cursor: default;
    outline: none;

    &:focus,
    &:active {
      border-color: #64748B;
    }
  }
}
</style>

<style>
:-webkit-autofill {
  animation-name: onAutoFillStart;
}

:not(:-webkit-autofill) {
  animation-name: onAutoFillCancel;
}

@keyframes onAutoFillStart {
  from {
  }
  to {
  }
}

@keyframes onAutoFillCancel {
  from {
  }
  to {
  }
}
</style>
